import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Mail } from "lucide-react";
import { FaLinkedinIn } from "react-icons/fa";
import { fadeUpItem, staggerContainer } from "../../animations/variants";
import { usePrefersReducedMotion } from "../../hooks/usePrefersReducedMotion";
import "./Contact.css";

function Contact() {
  const { t } = useTranslation();
  const prefersReducedMotion = usePrefersReducedMotion();
  const container = prefersReducedMotion ? {} : staggerContainer(0.08);
  const item = prefersReducedMotion ? {} : fadeUpItem;

  return (
    <section id="contact" className="contact">
      <motion.div
        className="section-inner contact-inner"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
        variants={container}
      >
        <motion.h2 className="section-title" variants={item}>
          {t("contact.title")}
        </motion.h2>
        <motion.p className="contact-body" variants={item}>
          {t("contact.body")}
        </motion.p>
        <motion.div className="contact-cta-row" variants={item}>
          <a href="mailto:bachaouiyoussef02@gmail.com" className="btn-primary">
            <Mail size={16} aria-hidden="true" /> {t("contact.ctaEmail")}
          </a>
          <span className="contact-or">{t("contact.or")}</span>
          <a
            href="https://it.linkedin.com/in/youssef-bachaoui-926a061a1"
            target="_blank"
            rel="noreferrer"
            className="btn-secondary"
          >
            <FaLinkedinIn size={16} aria-hidden="true" /> {t("contact.ctaLinkedin")}
          </a>
        </motion.div>
      </motion.div>
    </section>
  );
}

export default Contact;
